import React, { useState } from "react";
import { Button, Form, PageHeader } from "antd";
import { useIntl } from "react-intl";

import ItemForm from "../ItemForm";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { createItem } from "../../../redux/actions";

export default () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const history = useHistory();

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const onSubmit = () => {
    const values = form.getFieldsValue();
    setLoading(true);
    dispatch(createItem(values))
      .then(({ payload }) => history.push(`/items/${payload._id}`))
      .catch(() => setLoading(false));
  };

  return (
    <div className="page-wrapper">
      <PageHeader
        className="site-page-header-ghost-wrapper"
        ghost={false}
        title={intl.formatMessage({ id: "createItem" })}
        extra={[
          <Button
            disabled={loading}
            key="create"
            type="primary"
            onClick={onSubmit}
          >
            {intl.formatMessage({ id: "create" })}
          </Button>,
        ]}
      />
      <ItemForm form={form} />
    </div>
  );
};
